import React from 'react';
import Grid from '@mui/material/Grid';
// import Avatar from '@mui/material/Avatar';
import { Link, Typography } from '@mui/material';



const CCA2026 = () => {
  return (
    
    <Typography align='center' variant='h4' fontWeight={800}>
    Co-Curricular Activities 2026-27</Typography>
  );
};

export default CCA2026;
